module.exports = __webpack_public_path__ + "img/[亲亲].47a9eae1.svg";